import { render, staticRenderFns } from "./HeaderActionSaveButtons.vue?vue&type=template&id=37a7a53e&scoped=true"
import script from "./HeaderActionSaveButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionSaveButtons.vue?vue&type=script&lang=js"
import style0 from "./HeaderActionSaveButtons.vue?vue&type=style&index=0&id=37a7a53e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7a53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a7a53e')) {
      api.createRecord('37a7a53e', component.options)
    } else {
      api.reload('37a7a53e', component.options)
    }
    module.hot.accept("./HeaderActionSaveButtons.vue?vue&type=template&id=37a7a53e&scoped=true", function () {
      api.rerender('37a7a53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderActionSaveButtons.vue"
export default component.exports